export const nullMethod = () => ({});

export { default as StrictDict } from './StrictDict';
export { default as keyStore } from './keyStore';
export { default as dateFormatter } from './dateFormatter';
